import React, { useState } from "react";
import { AiOutlineMail } from "react-icons/ai";
import { BiPhoneCall } from "react-icons/bi";
import { mail, phone } from "../Constants/Constants";
import "./Contact.css";

export default function Contact({ setModal }) {
  const [register, setRegister] = useState({
    name: "",
    message: "",
  });
  let name, value;
  const getUserData = (event) => {
    name = event.target.name;
    value = event.target.value;
    console.log(name, value);
    setRegister({ ...register, [name]: value });
  };

  const postData = async (e) => {
    e.preventDefault();
    const { name, message } = register;

    if (name && message) {
      const res = await fetch(
        "https://bornxbobbysitecontact-dcf93-default-rtdb.firebaseio.com/bornxbobby.json",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name,
            message,
          }),
        }
      );
      if (res) {
        setRegister({
          message: "",
        });
        alert("Data Store Successfully");
      }
    } else {
      alert("Please fill all the data");
    }
  };
  return (
    <>
      <br />
      <hr id="contact" style={{ border: "1px solid white" }} className="my-0" />
      <div class="container-fluid  contact">
        <div className=" my-0 p-3 p-sm-0 row align-items-center"></div>
        <div class="row p-sm-5">
          <h5 data-aos="zoom-in-up" className="heading my-1">
            Contact us
          </h5>
          <div class="col-lg-4 col-md-6 my-5">
            <div data-aos="flip-left">
              <iframe
                className="rounded"
                title="Bornxbobby"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3598.1738329845534!2d85.15602005092259!3d25.599139283630866!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ed59ee933efca5%3A0x7a5fa9c649130db5!2sAiMiT%20College!5e0!3m2!1sen!2sin!4v1660037765519!5m2!1sen!2sin"
                width="100%"
                height="400"
                style={{ border: "0" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
          <div
            data-aos="zoom-in-right"
            className="col-lg-4 col-md-4 my-5 Toggler"
          >
            <a className="nav_text navbar-brand text-white" href="/">
              <h1>
                {"<"} BORNXBOBBY{"/>"}
              </h1>
            </a>
            <p style={{ color: "white" }} className="text-start paragraphs">
              O/42 Doctors Colony Main Road No, Near, Rajendra Nagar Over
              Bridge, opp. PNB Building, Kankarbagh, Patna, Bihar 800020
            </p>
            <a
              className="text-start caro_Btn paragraphs"
              style={{ border: "none", padding: "0", letterSpacing: "0.2px" }}
              href={phone}
            >
              <BiPhoneCall /> Get in Touch : {phone.slice(4)}
            </a>
            <br />
            <a
              className="text-start caro_Btn paragraphs"
              style={{ border: "none", padding: "0", letterSpacing: "0.2px" }}
              href={mail}
            >
              <AiOutlineMail /> Mail Us : {mail.slice(7)}
            </a>
            <br />
            <button
              onClick={() => setModal((toggle) => !toggle)}
              id="myBtn"
              style={{ border: "none", padding: "0", letterSpacing: "0.2px" }}
              className="text-start caro_Btn paragraphs"
            >
              Terms of Services
            </button>
          </div>

          <div className="Form ">
            <div className="Main">
              <label> Name:- </label> <br />
              <input
                placeholder="Name"
                type="name"
                name="name"
                value={register.name}
                onChange={getUserData}
              />
              <br />
              <br />
              <label> Message:- </label> <br />
              <input
                placeholder="Message"
                value={register.message}
                onChange={getUserData}
                type="message"
                name="message"
              />
              <br />
              <br />
              <button onClick={postData} className="bu" type="message">
                Send message
              </button>
              <br />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
